var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_755_13098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 0.000488281C26.3892 0.000488281 3.99976 22.386 3.99976 50.0007C3.99976 72.0924 18.3263 90.8345 38.1931 97.4461C40.6918 97.9088 41.6094 96.3614 41.6094 95.0406C41.6094 93.8485 41.5627 89.9095 41.5416 85.7316C27.6311 88.7562 24.6959 79.8322 24.6959 79.8322C22.4215 74.0528 19.1443 72.5163 19.1443 72.5163C14.608 69.4129 19.4863 69.4765 19.4863 69.4765C24.5073 69.8294 27.1511 74.6292 27.1511 74.6292C31.6105 82.2733 38.8479 80.0631 41.7012 78.7859C42.1498 75.5539 43.4458 73.3485 44.8756 72.0999C33.7701 70.8352 22.0952 66.5479 22.0952 47.3894C22.0952 41.9308 24.0485 37.4701 27.2472 33.9687C26.728 32.7091 25.0167 27.6238 27.7315 20.7366C27.7315 20.7366 31.9301 19.3927 41.4851 25.8619C45.4732 24.7537 49.7507 24.1985 54 24.1796C58.2492 24.1985 62.5298 24.7537 66.5258 25.8619C76.0694 19.3927 80.2622 20.7366 80.2622 20.7366C82.9836 27.6238 81.2715 32.7091 80.7523 33.9687C83.9581 37.4701 85.898 41.9304 85.898 47.3894C85.898 66.5934 74.2012 70.8223 63.0675 72.0599C64.8607 73.6116 66.4587 76.6546 66.4587 81.3192C66.4587 88.0091 66.4007 93.3936 66.4007 95.0406C66.4007 96.3712 67.3007 97.9304 69.8355 97.4394C89.6912 90.8204 104 72.085 104 50.0007C104 22.386 81.6135 0.000488281 54 0.000488281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7264 71.227C22.6166 71.4752 22.2252 71.5498 21.8696 71.3796C21.5068 71.2164 21.3029 70.8776 21.4206 70.6282C21.5284 70.3725 21.9198 70.3012 22.2817 70.4729C22.6452 70.6357 22.8523 70.9776 22.7264 71.227ZM25.1859 73.4215C24.9475 73.6426 24.4812 73.5399 24.1648 73.1905C23.8377 72.8419 23.7766 72.376 24.0185 72.1513C24.2644 71.9305 24.7165 72.0337 25.0444 72.3827C25.3714 72.7352 25.4349 73.1983 25.1855 73.4218L25.1859 73.4215ZM26.8733 76.2292C26.5667 76.4421 26.0655 76.2425 25.7561 75.7978C25.4498 75.3535 25.4498 74.8202 25.7628 74.6065C26.0733 74.3928 26.5667 74.5849 26.8804 75.0261C27.1862 75.4782 27.1862 76.0116 26.8729 76.2296L26.8733 76.2292ZM29.7266 79.4812C29.4524 79.7832 28.8689 79.7024 28.4415 79.2899C28.0047 78.8868 27.8827 78.3146 28.1576 78.0123C28.4348 77.7095 29.0219 77.7946 29.4524 78.2036C29.8865 78.606 30.0191 79.1824 29.7269 79.4812H29.7266ZM33.4143 80.5792C33.2939 80.9706 32.7316 81.1486 32.1653 80.9824C31.5998 80.811 31.2296 80.3522 31.3438 79.9565C31.4614 79.5624 32.0261 79.3769 32.5967 79.555C33.1613 79.7255 33.5323 80.1808 33.4147 80.5792H33.4143ZM37.6118 81.0447C37.6259 81.4573 37.1455 81.7992 36.551 81.8067C35.953 81.8196 35.4695 81.4859 35.4632 81.0804C35.4632 80.6639 35.9326 80.3251 36.5302 80.3153C37.1247 80.3036 37.6118 80.6349 37.6118 81.0447ZM41.7348 80.8867C41.8061 81.289 41.3928 81.7023 40.8027 81.8121C40.2223 81.918 39.685 81.6698 39.6109 81.271C39.5388 80.8584 39.9599 80.4455 40.5391 80.3385C41.1305 80.2357 41.6595 80.4777 41.7348 80.8867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_755_13098",
    x: -0.000244141,
    y: 0.000488281,
    width: 108,
    height: 105.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_755_13098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_755_13098",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d2efdfbf3e024d3b7913c58053d23717.svg";
export { ForwardRef as ReactComponent };